enum CalendarFetchOrder {
    Ascending,
    Descending,
}

export default CalendarFetchOrder;
